export default function OutOfNetworkIcon({ width = 12, height = 12, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <circle cx='6' cy='6' r='6' fill='#fff' />
      <path
        fill='#d4405e'
        d='M6 0C2.7 0 0 2.7 0 6s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6m3 6.375a.375.375 0 0 1-.375.375h-5.25A.375.375 0 0 1 3 6.375v-.75c0-.207.168-.375.375-.375h5.25c.207 0 .375.168.375.375z'
      />
    </svg>
  );
}
